export default "__VITE_ASSET__4efd5d46__"